import { NewUser } from 'models/user';
import { SetToken } from './auth';
import { Api } from './api';
import { message } from 'antd';
import { setFrontendVersionCookie } from './me.service';

// TODO: Could be a shared library
export interface SigninRequest {
  email: string;
  password: string;
}
export interface SigninResponse {
  token: string;
}

export interface SignupResponse {
  token?: string;
}

export interface SignupRequest {
  email: string;
  password: string;
  partnerCode?: string;
  referralCode?: string;
  invitation?: string;
}

export interface ForgotPasswordRequest {
  email: string;
}

export type ChangeEmailRequest = ForgotPasswordRequest;

export interface ChangeEmailConfirmationResponse {
  email: string;
}

export interface ResetPasswordRequest {
  password: string;
}

export interface SwitchDto {
  idOrganization: string;
}

export enum InvitationAction {
  Accept = 'Accept',
  Decline = 'Decline',
}

export interface InvitationDto {
  code: string;
  action: InvitationAction;
}

export const Signin = async (data: SigninRequest) => {
  const result = await Api.post<SigninRequest, SigninResponse>('/auth/signin', data);
  SetToken(result.token);
  return result;
};

export const Switch = async (data: SwitchDto) => {
  const result = await Api.post<SwitchDto, SigninResponse>('/auth/switch', data);
  SetToken(result.token);
  return result;
};

export const Signup = async (data: SignupRequest) => {
  const result = await Api.post<SignupRequest, SignupResponse>('/auth/signup', data);
  if (result.token) {
    SetToken(result.token);
  }
  return result;
};

export const ForgotPassword = async (data: ForgotPasswordRequest) => {
  const result = await Api.post<ForgotPasswordRequest, NewUser>('/auth/forgot-password', data);
  return result;
};

export const ResetPassword = async (code: string, data: ResetPasswordRequest) => {
  const result = await Api.post<ResetPasswordRequest, NewUser>(`/auth/forgot-password/${code}`, data);
  message.success('Your password has been updated sucessfully!');
  return result;
};

export const Confirmation = async (code: string) => {
  const result = await Api.post<never, SigninResponse>(`/auth/confirmation/${code}`);
  SetToken(result.token);
  return result;
};

export const ChangeEmail = async (newEmail: string) => {
  const result = await Api.put<ChangeEmailRequest, void>(`/me/change-email`, { email: newEmail });
  message.success('A confirmation email has been sent to your email address');
  return result;
};

export const ChangePlan = async (partnerCode: string) => {
  const result = await Api.put<any, void>(`/me/change-plan`, { partnerCode });
  message.success('Plan changed successfully');
  return result;
};

interface ToggleFrontendVersionResponse {
  frontendVersion: string;
}

export const ToggleFrontendVersion = async () => {
  const result = await Api.put<any, ToggleFrontendVersionResponse>(`/me/toggle-frontend-version`);
  setFrontendVersionCookie(result.frontendVersion);
  return result;
};

export const ChangeEmailConfirmation = async (code: string) => {
  const result = await Api.post<never, ChangeEmailConfirmationResponse>(`/auth/change-email/${code}`);
  message.success('Email changed sucessfully!');
  return result;
};

export async function Invitation(data: InvitationDto) {
  const result = await Api.post<InvitationDto, void>(`/auth/invitation`, data);
  message.success('Invitation updated successfully');
  return result;
}
